module.exports = __webpack_public_path__ + "src/client/screens/Login/illustration.svg";